const baseurl = process.env.REACT_APP_BACKEND_URL

const URL_LOGIN = `${baseurl}auth/login`
const URL_GRADE = `${baseurl}grade`
const URL_GRADE_ALL = `${baseurl}grade-all`
const URL_GRADE_KINDERGATEN = `${baseurl}grade-kindergaten`
const URL_KELAS = `${baseurl}kelas/`
const URL_MAPEL = `${baseurl}mapel/`
const URL_SEN = `${baseurl}sen/`
const URL_PROJEK = `${baseurl}projek/`
const URL_GURU = `${baseurl}guru/`
const URL_SISWA = `${baseurl}siswa/`
const URL_ASPEK_PERKEMBANGAN = `${baseurl}aspek-perkembangan/`


const data = {
  URL_LOGIN, URL_GRADE, URL_GRADE_ALL, URL_GRADE_KINDERGATEN, URL_MAPEL, URL_KELAS, URL_PROJEK, URL_GURU, URL_SISWA, URL_ASPEK_PERKEMBANGAN, URL_SEN
}

export default data

